module.exports = __webpack_public_path__ + "static/media/hardware.f93473d8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/hardware.png
 ** module id = 633
 ** module chunks = 0
 **/